import React, { Component } from 'react';
import SellerCard from './sellerCard';

export default class RugSellersRow extends Component {

    state = {
        rugs: [],
        selectedRug: {},
        selectedRugIndex: 0,
        similarRugsLoaded: false,
        similarRugs: [],
        activeSimilarRugs: [],
        sellers: [],
        sellersOrder: "",
    }

    render() {
        let sellers = this.props.sellers.map((seller) => <SellerCard texts={this.props.texts} seller={seller} key={"seller" + seller.id} />)
        return (
            <div className="row mb-5">
                {sellers}
            </div>
        )
    }
}